<template>
  <div
    class="qty-eye"
    :class="{
      'athena-cart-page': mode == 'athena_cart_page',
      'athena-inline-cart': mode == 'athena-inline-cart',
    }"
  >
    (Qty 1=1 eye)
  </div>
</template>
<script>
export default {
  props: {
    mode: {},
  },
};
</script>
<style scoped lang='scss'>
.qty-eye {
  height: 20px;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  color: #db1704;
  line-height: 20px;
}
.athena-cart-page {
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  margin-top: 14px;
}
.athena-inline-cart {
  margin-top: -10px;
  margin-bottom: 10px;
}
@media screen and(max-width: 768px) {
  .athena-inline-page {
    font-size: 12px;
    margin-bottom: 7px;
  }
  .athena-cart-page {
    font-size: 12px;
    margin-top: 10px;
  }
}
</style>